/**
 * API paths for various CRUD operations
 */
export const apiPaths: { [key: string]: string } = {
  login: "admin/login",
  logout: "admin/logout",

  dashboard: "dashboard", // GET
  submissionSummary: "dashboard/submission-summary", // GET
  submissionAnalysis: "dashboard/submission-analysis", // GET
  filterOptions: "dashboard/filter-options", // GET
  submissionTestSeriesDetail: "dashboard/submission-analysis/test-series", // GET /:id
  sendNotification: "notification/send-notification", //POST
  verifyToken: "admin/verify-token", // GET

  //language
  getlanguage: "language", //GET
  createlanguage: "language",
  updatelanguage: "language",
  deleteLanguage: "language",

  //course
  getCourse: "course",
  createCourse: "course",
  updateCourse: "course",
  deleteCourse: "course",

  //standard
  getStandard: "standard",
  createStandard: "standard",
  updateStandard: "standard",
  deleteStandard: "standard",

  //banner
  getBanner: "banner",
  createBanner: "banner",
  updateBanner: "banner",
  deleteBanner: "banner",

  //Subject
  getSubject: "subject",
  createSubject: "subject",
  updateSubject: "subject",
  deleteSubject: "subject",

  //Users
  getUser: "user",
  deleteUser: "user",
  searchUsers: "user/search-student",
  disableUser: "user/disable",

  // Master Users
  fetchMasterUsers: "user/master-user",
  createMasterUser: "user/master-user",
  disableMasterUser: "user/disable-master-user",
  enableMasterUser: "user/enable-master-user",

  //books
  getbook: "books",
  createbook: "books",
  updatebook: "books",
  deletebook: "books",

  // e-paper (backend routes at /e-paper)
  getEPapers: "e-paper",
  createEPaper: "e-paper",
  updateEPaper: "e-paper",
  deleteEPaper: "e-paper",

  //testQuestion
  question: "questions",
  questionGeneratePdf: "questions/generate-pdf",
  bulkUpdateQuestions: "questions/bulk-update",
  updateQuestionStatus: "questions/update-status",
  getAllQuestions: "questions/all",

  //live mcq
  liveMcq: "live-mcq",

  //TestSeries
  getTestSeries: "test-series",
  createTestSeries: "test-series",
  updateTestSeries: "test-series",
  deleteTestSeries: "test-series",
  // addQuestion: "test-series/addQuestions",
  // deleteQuestion:"test-series/deleteQuestion/delete",
  getTestSeriesById: "test-series",

  // Transactions
  getTransactions: "payment/admin/transactions",

  //categories
  getAllCategories: "category",

  // Static Pages
  privacyPolicy: "privacy-policy",
  aboutUs: "about-us",
  help: "help",

  //getArticles
  getArticles: "article/get-articles",
  uploadFile: "article/upload-file",
  createArticle: "article/create-article",
  updateArticle: "article/update",
  getArticle: "article",
  deleteArticle: "article/delete",

  // Coupons
  coupons: "coupon",
  createCouponCategory: "coupon/create-coupon-category",
  editCategory: "coupon/edit-category",
  deleteCategory: "coupon/categories",
  deleteCoupon: "coupon/",

  // Permission Management
  permissions: "permissions",
  adminPermissions: "permissions/admin-permissions",

  // Cron Settings
  getCronSettings: "send-cron-question",
  getCronSettingById: "send-cron-question",
  updateCronSetting: "send-cron-question",
  resetCron: "send-cron-question",
};
